"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailUpdatePrimarySignature = exports.gmailUpdatePrimarySignatureResultSchema = exports.gmailUpdatePrimarySignatureArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailUpdatePrimarySignatureArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('update-primary-signature', zod_1.z.object({
    signature: zod_1.z
        .string()
        .describe('The new signature content to set for the primary email address'),
}));
exports.gmailUpdatePrimarySignatureResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.object({
    response: zod_1.z.object({}).describe('Response from the Gmail API'),
    summary: zod_1.z.string().describe('Success message with the email address that was updated'),
}));
exports.gmailUpdatePrimarySignature = (0, common_1.createToolMetadata)({
    id: 'gmailUpdatePrimarySignature',
    displayName: 'Gmail Update Primary Signature',
    displayDescription: 'Update the signature for the primary email address',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailUpdatePrimarySignatureArgsSchema,
}, exports.gmailUpdatePrimarySignatureResultSchema);
